import type * as GraphQLTypes from '../../../graphql/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdatePackageMutationVariables = GraphQLTypes.Exact<{
  id: GraphQLTypes.Scalars['String'];
  input: GraphQLTypes.UpdatePackageInput;
}>;


export type UpdatePackageMutationResult = (
  { __typename?: 'Mutation' }
  & { updatePackage?: GraphQLTypes.Maybe<(
    { __typename?: 'Package' }
    & Pick<GraphQLTypes.Package, 'id'>
  )> }
);


export const UpdatePackageDocument = /*#__PURE__*/ gql`
    mutation updatePackage($id: String!, $input: UpdatePackageInput!) {
  updatePackage(id: $id, input: $input) {
    id
  }
}
    `;

/**
 * __useUpdatePackageMutation__
 *
 * To run a mutation, you first call `useUpdatePackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePackageMutation, { data, loading, error }] = useUpdatePackageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePackageMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePackageMutationResult, UpdatePackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePackageMutationResult, UpdatePackageMutationVariables>(UpdatePackageDocument, options);
      }
export type UpdatePackageMutationHookResult = ReturnType<typeof useUpdatePackageMutation>;